export default {
      id: "collaborate-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#collaborate",
      toString: function () {
        return this.url;
      }
    }